import { useEffect, useState } from 'react';

import { Intangible } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

import useGetasPath from '@hooks/useGetasPath';

export const BreadCrumbHotelListSchemaOrg = ({
  actionPageLocationLabel,
}: {
  actionPageLocationLabel: string;
}) => {
  const path = useGetasPath();
  const url = `${process.env.NEXT_PUBLIC_HOST}${path}`;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Don't render anything on the server
  if (!mounted) return null;

  // Only render when we have a valid label
  if (!actionPageLocationLabel?.trim()) {
    return null;
  }
  return (
    <Script
      defer
      {...jsonLdScriptProps<Intangible>({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Setur',
            item: `${process.env.NEXT_PUBLIC_HOST}/`,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: actionPageLocationLabel,
            item: url,
          },
        ],
      })}
    />
  );
};
